import Vue from "vue";
import axios from "axios";

const GraphqlData = new Vue({
  data() {
    return {};
  },
  created() {},
  methods: {
    authenticateAndFetchData(manufacturer, component, model, trim) {
      if (component == "bp-models") {
        return this.getModelsData(null, manufacturer, component);
      }
      if (component == "bp-categories") {
        return this.getCategories(null, manufacturer, component);
      }
      if (component == "bp-trims") {
        return this.getTrimsData(null, manufacturer, model, component);
      }
      if (component == "bp-detail") {
        return this.getTrimData(null, manufacturer, model, component, trim);
      }
      if (component == "special-offers") {
        return this.specialOffers(null);
      } else {
        return null;
      }
    },
    fetchData(authToken, query, component) {
      return axios
        .post(
          `${process.env.MIX_GRAPHQL_URL}`,
          {
            query: query,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        )
        .then((response) => {
          if (response.data.errors) {
            throw new Error(response.data.errors[0].message);
          } else {
            if (component == "bp-models" || component == "bp-categories")
              return response.data.data.modelLists.nodes;
            else if (component == "bp-trims") {
              return response.data.data;
            } else if (component == "bp-detail") {
              return response.data.data;
            } else if (component == "special-offers") {
              return response.data.data.offers.nodes;
            } else return null;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getCategories(authToken, manufacturer, component) {
      const query = `        {
        modelLists(first: 100, where: { search: "${manufacturer}" }) {
          nodes {
            modelData {
              category
            }
            }
          }
        }`;

      return this.fetchData(authToken, query, component)
        .then((response) => {
          // Convert response data to object
          let categories = {};
          response.forEach((item) => {
            if (!categories[item.modelData.category]) {
              categories[item.modelData.category] = 1;
            }
          });
          // remove duplicates from object
          categories = Object.keys(categories);

          const allCategories = categories.reduce((result, category) => {
            return result.concat(category.split(",").map((c) => c.trim()));
          }, []);

          // Paso 2: Eliminar duplicados
          const uniqueCategories = [...new Set(allCategories)];

          // Add "All" category first
          uniqueCategories.unshift("All");

          return uniqueCategories;
        })
        .catch((error) => {
          console.error("Error fetching categories:", error);
          throw error;
        });
    },
    getModelsData(authToken, manufacturer, component) {
      const query = `        {
        modelLists(first: 100, where: { search: "${manufacturer}", orderby: {field: DATE, order: ASC} }) {
          nodes {
            modelData {
              category
              year
              make
              model
              startingPrice
              fuel
              features
              financeOffers {
                term
                rate
                regionKey
              }
              leaseOffers {
                term
                rate
                mileage
                residual
                regionKey
              }
              jellybean {
                sourceUrl(size: THUMBNAIL)
              }
            }
            }
          }
        }`;

      return this.fetchData(authToken, query, component);
    },
    getTrimsData(authToken, manufacturer, model, component) {
      model = model.replace(/ /g, "-").trim();

      const query = `
      {
        modelList(id: "${model}", idType: SLUG) {
          title
          modelData {
            year
            make
            model
            trims {
              ... on ModelTrim {
                trimData {
                  name
                  fuel
                  features
                  description
                  descriptionFr
                  startingPrice
                  category
                  jellybean {
                    sourceUrl(size: THUMBNAIL)
                  }
                }
              }
            }
          }
        }
        options(first: 100, where: {search: "${model
          .replace(/-/g, " ")
          .trim()}"}) {
          nodes {
            options {
              category
              preselector
              items {
                code
                dataCondition
                description
                name
                price
                icon
                trims {
                  ... on ModelTrim {
                    trimData {
                      name
                    }
                  }
                }
              }
            }
          }
        }
      }`;

      return this.fetchData(authToken, query, component);
    },
    getTrimData(authToken, manufacturer, model, component, trim) {
      if (model && trim) {
        model = model.replace(/ /g, "-").trim();
        trim = trim.replace(/ /g, "-").trim();

        const query = `
        {
          modelTrim(id: "${model}-${trim}", idType: SLUG) {
            trimData {
              startingPrice
              colorizer {
                isJellybean
                colorName
                colorNameFr
                hexCode
                price
                images {
                  imageType
                  style
                  image {
                    sourceUrl(size: LARGE)
                  }
                }
              }
              financeOffers {
                isBestOffer
                term
                rate
                regionKey
              }
              leaseOffers {
                isBestOffer
                rate
                mileage
                regionKey
                term
                residual
              }
              interior {
                price
                name
                hexCode
              }
            }
          }
          options(first: 100, where: {search: "${model
            .replace(/-/g, " ")
            .trim()}"}) {
            nodes {
              options {
                category
                preselector
                items {
                  code
                  dataCondition
                  description
                  name
                  price
                  icon
                  image {
                    sourceUrl(size: THUMBNAIL)
                  }
                  trims {
                    ... on ModelTrim {
                      trimData {
                        name
                      }
                    }
                  }
                }
              }
            }
          }
        }`;

        return this.fetchData(authToken, query, component);
      } else return null;
    },
    specialOffers(authToken) {
      const query = `
      {
        offers(first: 1000) {
          nodes {
            title
            offers {
              notAVehicle
              year
              make
              model
              trim
              contentAlignment
              legalEn
              legalFr
              downPayment
              downPaymentLabel
              leaseLabel
              leaseDisclaimer
              leaseApr
              financeApr
              financeDisclaimer
              financeLabel
              financeLegalEn
              paymentLabel
              paymentTaxLabel
              payment
              paymentDisclaimer
              normalOfferLine1
              normalOfferLine2
              province
              startDate
              endDate
              desktopImage {
                sourceUrl
              }
              mobileImage {
                sourceUrl
              }
            }
          }
        }
      }`;

      return this.fetchData(authToken, query, "special-offers");
    },
  },
});

export default GraphqlData;